import MyRoutes from "./routers/Router";
import TranslateBox from "./Components/translate";
import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';

function App() {
  return (
    <Router>
      <div className="App">
        <TranslateBox />
        <MyRoutes />
      </div>
    </Router>
  );
}

export default App;
